import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { createContext, useEffect, useState } from 'react';
import PropTypes from "prop-types";
import * as stylex from '@stylexjs/stylex';
export var ContextMenuContext = /*#__PURE__*/createContext();
export default function ContextMenu(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isAddedToDom = _useState2[0],
    setIsAddedToDom = _useState2[1];
  var uid = props.id;
  useEffect(function () {
    var _props$sender;
    var floater = document.getElementById(uid);
    var sender = (_props$sender = props.sender) === null || _props$sender === void 0 ? void 0 : _props$sender.getBoundingClientRect();
    if (floater) {
      var context = floater.getBoundingClientRect();
      floater.style.position = "absolute";
      floater.style.opacity = 1;
      floater.style.marginTop = "".concat(context.height / 2 * -1, "px");
      floater.style.inset = "unset";
      floater.style.left = "".concat(sender.x - context.width - 10, "px");
      // floater.style.transition = `left 0.2s ease`;
      floater.showPopover();
      setIsAddedToDom(true);
    }
    floater.addEventListener('beforetoggle', function (e) {
      if (e.newState === 'closed') {
        var _props$_wasClosed;
        (_props$_wasClosed = props._wasClosed) === null || _props$_wasClosed === void 0 || _props$_wasClosed.call(props);
      }
    });
    return function () {};
  }, []);
  useEffect(function () {
    if (isAddedToDom) {
      setTimeout(function () {}, 100);
    }
  }, [isAddedToDom]);
  var __collect = function __collect(context_value) {
    var _props$__collect;
    (_props$__collect = props.__collect) === null || _props$__collect === void 0 || _props$__collect.call(props, context_value);
  };
  return props.show ? /*#__PURE__*/React.createElement(ContextMenuContext.Provider, {
    value: {
      __collect: __collect
    }
  }, /*#__PURE__*/React.createElement("div", _extends({}, {
    className: "ContextMenu__ui.base ev15elmyd ev1y7ric0 ev1717udv evxwrc4x evrostsh ev8nb66u ev10l6tqk"
  }, {
    id: uid,
    style: {
      opacity: '0'
    },
    popover: ""
  }), /*#__PURE__*/React.createElement("ol", {
    className: "ContextMenu__ui.options eve8uvvx ev1717udv ev1ghz6dp"
  }, props.children))) : /*#__PURE__*/React.createElement(React.Fragment, null);
}
ContextMenu.propTypes = {
  show: PropTypes.bool,
  __click: PropTypes.func,
  context: PropTypes.array,
  _wasClosed: PropTypes.func,
  sender: PropTypes.object
};
_inject(".ev15elmyd{border:1px solid var(--shade-light)}", 1000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".evrostsh{width:150px}", 4000);
_inject(".ev8nb66u{box-shadow:0 20px 50px rgba(0,0,0,.4)}", 3000);
_inject(".ev10l6tqk{position:absolute}", 3000);
_inject(".eve8uvvx{list-style:none}", 2000);
_inject(".ev1ghz6dp{margin:0}", 1000);